export const savedCardStatuses = [
  {
    value: 5,
    text: 'enabled',
    theme: 'success',
    icon: 'Check'
  },
  { value: 8, text: 'disabled', theme: 'danger', icon: 'Close' },
  { value: 9, text: 'failed', theme: 'danger', icon: 'Close' }
];

export const sddMandateLanguages = [
  {
    value: 'de',
    text: 'de',
    icon: 'de'
  },
  {
    value: 'en',
    text: 'en',
    icon: 'en'
  },
  {
    value: 'es',
    text: 'es',
    icon: 'es'
  },
  {
    value: 'fr',
    text: 'fr',
    icon: 'fr'
  },
  {
    value: 'it',
    text: 'it',
    icon: 'it'
  }
];

export const sddMandateStatuses = [
  { value: 0, text: 'pendingValidation', theme: 'warning', icon: 'Clock' },
  {
    value: 5,
    text: 'validated',
    theme: 'success',
    icon: 'Check'
  },
  {
    value: 6,
    text: 'enabled',
    theme: 'success',
    icon: 'Check'
  },
  { value: 8, text: 'disabled', theme: 'neutral', icon: 'Close' },
  { value: 9, text: 'rejected', theme: 'danger', icon: 'Close' }
];

export const virtualIbanCountries = {
  be: {
    bank: 'BNP Paribas Fortis',
    value: 'fr',
    icon: 'be'
  },
  de: {
    bank: 'BNP Paribas Niederlassung',
    value: 'de',
    icon: 'de'
  },
  es: {
    bank: 'BNP Paribas Sucursal en España',
    value: 'es',
    icon: 'es'
  },
  fr: {
    bank: 'BNP Paribas',
    value: 'fr',
    icon: 'fr'
  },
  it: {
    bank: 'Banca Nazionale del Lavoro S.P.A.',
    value: 'it',
    icon: 'it'
  }
};
